export * from './common';
export * from './layout';
export * from './msi';
import { ActivityState, RewardType, BizLineDesc, AmountType, PrizeStatus } from '../types';
export const getPrizeInfoByTime = (userPrizeInfos, inDrawTime, startTime, endTime) => {
    if (!inDrawTime)
        return undefined;
    if (!Array.isArray(userPrizeInfos) || userPrizeInfos.length === 0) {
        return undefined;
    }
    // 从后往前查找，返回最后一个符合条件的奖励
    return [...userPrizeInfos].reverse().find(prize => {
        const drawTime = prize.drawTime;
        const rewardType = prize.rewardType;
        return drawTime !== undefined && drawTime >= startTime && drawTime <= endTime;
    });
};
export function getCouponPackageInDraw(drawModuleInfo, realPackagePrizeUuids = []) {
    if (!drawModuleInfo)
        return null;
    const { userPrizeInfos, inDrawTime, currentDrawTimeStart, currentDrawTimeEnd } = drawModuleInfo;
    const userPrizeInfo = getPrizeInfoByTime(userPrizeInfos, inDrawTime, currentDrawTimeStart, currentDrawTimeEnd);
    if (userPrizeInfo && userPrizeInfo.rewardType === RewardType.Package && realPackagePrizeUuids.includes(userPrizeInfo.uuid)) {
        return userPrizeInfo;
    }
    return null;
}
export const generateStateFromDrawModule = (lotteryModuleInfo, hasAppointment, realPackagePrizeUuids = []) => {
    const { inDrawTime, drawChance, currentDrawTimeStart, currentDrawTimeEnd, hasNextDrawTime, userPrizeInfos } = lotteryModuleInfo;
    const userPrizeInfo = getPrizeInfoByTime(userPrizeInfos, inDrawTime, currentDrawTimeStart, currentDrawTimeEnd);
    if (userPrizeInfo && userPrizeInfo.rewardType === RewardType.Package && realPackagePrizeUuids.includes(userPrizeInfo.uuid))
        return ActivityState.REWARD_PACKAGE;
    if (inDrawTime && drawChance > 0) {
        if (userPrizeInfo) {
            return ActivityState.DRAWN_HAS_CHANCES;
        }
        return ActivityState.UNRESERVED_CAN_DRAW;
    }
    if (inDrawTime && drawChance <= 0) {
        return ActivityState.DRAWN_NO_CHANCES;
    }
    if (!inDrawTime && hasNextDrawTime) {
        if (hasAppointment) {
            return ActivityState.RESERVED;
        }
        return ActivityState.CAN_RESERVE;
    }
    if (!hasNextDrawTime)
        return ActivityState.END;
    return ActivityState.END;
};
// 获取中了券包但是只有部分券发放成功的弹窗展示信息
export const getPrizeModalInfo = (userPrizeInfos, isCanUseFilter = false) => {
    // 先过滤出已领取正常的券
    let filteredPrizes = userPrizeInfos.filter(prize => [PrizeStatus.NOT_USED, PrizeStatus.USED, PrizeStatus.EXPIRED, PrizeStatus.DRAWN].includes(prize.prizeStatus));
    if (isCanUseFilter) {
        // 过滤出可使用的券
        filteredPrizes = filteredPrizes.filter(prize => prize.prizeStatus === PrizeStatus.DRAWN || prize.prizeStatus === PrizeStatus.NOT_USED);
    }
    const result = {
        title: `出游券${filteredPrizes.length > 1 ? '包' : ''}`,
        desc: '',
        isPackage: filteredPrizes.length > 1
    };
    // 按 amountType 归类，value 为业务线描述数组
    const groupByAmountType = new Map();
    filteredPrizes.forEach(prize => {
        var _a;
        const bizLineDesc = BizLineDesc[prize.bizLine] || '';
        const key = prize.amountType;
        if (!groupByAmountType.has(key)) {
            groupByAmountType.set(key, []);
        }
        (_a = groupByAmountType.get(key)) === null || _a === void 0 ? void 0 : _a.push(bizLineDesc);
    });
    // 遍历 map，按 amountType 拼接成描述字符串
    const descParts = [];
    // 按照 key 排序：折扣(2) 在前，满减(1) 在后
    const sortedKeys = Array.from(groupByAmountType.keys()).sort((a, b) => b - a);
    sortedKeys.forEach(amountType => {
        const bizLines = groupByAmountType.get(amountType) || [];
        // 去重：相同业务线只显示一次
        const uniqueBizLines = Array.from(new Set(bizLines)).filter(line => line);
        if (uniqueBizLines.length > 0) {
            // 最多取前三个业务线，超过三个加"等"
            const displayBizLines = uniqueBizLines.slice(0, 3);
            const hasMore = uniqueBizLines.length > 3;
            const bizLineStr = displayBizLines.join('、') + (hasMore ? '等' : '');
            if (amountType === AmountType.FullReduction) {
                descParts.push(`${bizLineStr}满减券`);
            }
            else if (amountType === AmountType.Discount) {
                descParts.push(`${bizLineStr} 5 折券`);
            }
        }
    });
    result.desc = `包含${descParts.join('、')}`;
    return result;
};
/**
 * 获取是否含有可领取的奖励
 * @param rewardModuleInfoVO
 * @returns
 */
export const getCanRewardPrizeInfo = (rewardModuleInfoVO) => {
    const { userPrizeInfos } = rewardModuleInfoVO || {};
    if (Array.isArray(userPrizeInfos) && userPrizeInfos.length) {
        return userPrizeInfos.filter(prize => {
            return [PrizeStatus.CAN_DRAW].includes(Number(prize.prizeStatus));
        });
    }
    return [];
};
/**
 * 获取领奖的奖励记录
 * @param rewardModuleInfoVO
 * @returns
 */
export const getRewardPrizeInfoRecord = (rewardModuleInfoVO) => {
    const { userPrizeInfos } = rewardModuleInfoVO || {};
    if (Array.isArray(userPrizeInfos) && userPrizeInfos.length) {
        return userPrizeInfos.filter(prize => {
            return [PrizeStatus.NOT_USED, PrizeStatus.USED, PrizeStatus.DRAWN].includes(Number(prize.prizeStatus));
        });
    }
    return [];
};
